'use strict';

const Reflux = require('@muzzylane/reflux');

const FeaturedDemoActions = require('../actions/FeaturedDemoActions');
const SignInActions = require('../actions/sign_in_actions');

let initialized = false;
let featuredDemos = [];
let action = {};

const FeaturedDemoStore = Reflux.createStore({
    listenables: [FeaturedDemoActions, SignInActions],

    init: function() { return; },

    resetState: function() {
        initialized = false;
        featuredDemos = [];
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            initialized: initialized,
            featuredDemos: featuredDemos,
            action: action
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onGetAllCompleted: function(actionId, res) {
        // console.log('onGetAllCompleted:', actionId, res);
        action = { id: actionId };
        initialized = true;
        featuredDemos = res;
        this.emitStatus();
    },

    onGetAllFailed: function(actionId, err) {
        console.warn("onGetAllFailed:", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
});

module.exports = FeaturedDemoStore;